export default {

  namespaced: true,

  state: () => ({


  }),

  mutations: {

  },

  actions: {
    postAccountTransfer({ dispatch, commit }, params) {
      return new Promise ((resolve, reject) => {
        axios.post("/erp/account/account-transfer", params)
          .then(response => {
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
        })
    }
  }
}
